var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conShow),expression:"conShow"}]},[_c('div',[_c('headMenu',{on:{"showApply":_vm.showApply}})],1),_vm._m(0)]),_c('applyDetails',{ref:"apply",on:{"returnPage":_vm.returnPage}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/news/xw.png"),"alt":""}})])])
}]

export { render, staticRenderFns }